module.exports = __webpack_public_path__ + "static/media/avatar6.ff6126af.png";